import * as actionType from "./actionTypes";
import { getRequestAuthed, postRequestAuthed, postFormAuthed, processError } from "../../utils/apiHandlers";
import { LOADING_STATE, LS_ITEM_ADMIN, NOTIF_TYPE } from "../../utils/stateTypes";
import _notif from "../notification";

const setProducts = (products) => (
  {
    type: actionType.SET_PRODUCTS,
    products,
  }
);

const setProduct = (product) => (
  {
    type: actionType.SET_PRODUCT,
    product,
  }
);

//Runs an admin request with a load state, storing the returned product (if any)
const productRequest = (lsItem, request, successText=null, successCB=null) => (
  (dispatch) => {
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));
    request(
      (product) => {
        if (product && product.id) {
          dispatch(setProduct(product));
        }
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
        if (successText) {
          dispatch(_notif.actions.queueNotification(successText, NOTIF_TYPE.SUCCESS));
        }
        if (successCB) {
          successCB(product);
        }
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);

/* =========================== PRODUCT LIST =========================== */

export const loadProducts = () => (
  (dispatch) => {
    const lsItem = LS_ITEM_ADMIN.PRODUCTS_LOAD;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    getRequestAuthed("/AdminProduct/Products",
      (products) => {
        dispatch(setProducts(products));
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);

//Moves a product up / down the list (the order products show on the site)
export const moveProduct = (products, index, offset) => (
  (dispatch) => {
    const reordered = [...products];
    const [moved] = reordered.splice(index, 1);
    reordered.splice(index + offset, 0, moved);
    dispatch(setProducts(reordered));

    postRequestAuthed("/AdminProduct/ReorderProducts",
      reordered.map((x) => x.id),
      () => {/* Already shown */},
      processError(dispatch, _notif, null, () => dispatch(loadProducts())),
    );
  }
);

/* =========================== SINGLE PRODUCT =========================== */

export const clearProduct = () => setProduct(null);

export const loadProduct = (productID) => (
  productRequest(LS_ITEM_ADMIN.PRODUCT_LOAD,
    (success, error) => getRequestAuthed(`/AdminProduct/Product/${productID}`, success, error))
);

//Creates the product when id is 0
export const saveProduct = (product, successCB) => (
  productRequest(LS_ITEM_ADMIN.PRODUCT_SAVE,
    (success, error) => postRequestAuthed("/AdminProduct/SaveProduct", product, success, error),
    "Product saved",
    successCB)
);

export const deleteProduct = (productID, successCB) => (
  productRequest(LS_ITEM_ADMIN.PRODUCT_DELETE,
    (success, error) => postRequestAuthed(`/AdminProduct/DeleteProduct/${productID}`, {}, success, error),
    "Product deleted",
    successCB)
);

/* =========================== IMAGES =========================== */

export const uploadImages = (productID, files) => {
  const formData = new FormData();
  Array.from(files).forEach((file) => formData.append("files", file));
  return productRequest(LS_ITEM_ADMIN.IMAGES_UPDATE,
    (success, error) => postFormAuthed(`/AdminProduct/UploadImages/${productID}`, formData, success, error));
};

export const deleteImage = (imageID) => (
  productRequest(LS_ITEM_ADMIN.IMAGES_UPDATE,
    (success, error) => postRequestAuthed(`/AdminProduct/DeleteImage/${imageID}`, {}, success, error))
);

export const reorderImages = (productID, imageIDs) => (
  productRequest(LS_ITEM_ADMIN.IMAGES_UPDATE,
    (success, error) => postRequestAuthed(`/AdminProduct/ReorderImages/${productID}`, imageIDs, success, error))
);
